export const maskedAssignedUnits = ({ method, duration }) => {
  return  method === "HOURS"
    ? `${+duration === 1
      ? "1 hora"
      : `${+duration} horas`}`
    : `${+duration === 1
      ? "1 servicio"
      : `${+duration} servicios`}`;
};